import "./hero.css";

const Hero = ({ children }) => {
  return (
    <section class="hero">
      <div class="hero-container">
        {children}
      </div>
    </section>
  );
}

export default Hero;